module.exports = require("./vi-VN");